export const validateHygineForm = (formValues, currentTaskIndex) => {
  let errors = {};
  const currentTask = formValues.allTasks[0];
  // const currentTask = formValues.allTasks[currentTaskIndex];

  if (!formValues.mobileNumber) {
    errors.mobileNumber = "Required!";
  }

  if (!currentTask.selectedTaskStatus) {
    errors.selectedTaskStatus = "Task status is required!";
  }

  if (
    currentTask.selectedTaskStatus?.info?.add_gym_req &&
    !currentTask.taskDescription.trim()
  ) {
    errors.taskDescription = "Task description is required!";
  }

  if (currentTask.taskImages.some((imgArr) => imgArr.length === 0)) {
    errors.taskImages = "At least one image is required for each slot!";
  }

  if (currentTask.taskVideos.some((vidArr) => vidArr.length === 0)) {
    errors.taskVideos = "At least one video is required for each slot!";
  }

  return errors;
};

export const validateHygineForm1 = (formValues) => {
  let errors = {};

  if (!formValues.mobileNumber) {
    errors.mobileNumber = "Required!";
  }

  if (!formValues.selectedTaskStatus) {
    errors.selectedTaskStatus = "Task status is required!";
  }

  if (formValues.taskImages.some((imgArr) => imgArr.length === 0)) {
    errors.taskImages = "At least one image is required for each slot!";
  }

  if (formValues.taskVideos.some((vidArr) => vidArr.length === 0)) {
    errors.taskVideos = "At least one video is required for each slot!";
  }

  if (formValues.selectedTaskStatus?.info?.add_gym_req) {
    if (!formValues.taskDescription?.trim()) {
      errors.taskDescription = "Task description is required!";
    }

    if (!formValues.selectedIssueType) {
      errors.selectedIssueType = "Issue Type is required!";
    }

    if (!formValues.selectedCategory) {
      errors.selectedCategory = "Category is required!";
    }

    if (!formValues.selectedSubCategory) {
      errors.selectedSubCategory = "Sub-Category is required!";
    }
  }

  return errors;
};
